import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getAttribute, deleteAttribute } from '../actions/AttributeActions';
import { Pane, Heading, Button } from 'evergreen-ui';

import DeleteDialog from '../../common/DeleteDialog/DeleteDialog';
import { Link } from 'react-router-dom';
import AttributeInfoBlock from '../components/AttributeInfoBlock';

class ViewAttribute extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    
    async componentDidMount() {
        await this.props.dispatch(getAttribute(this.id))
    }

    handleDelete = () => {
        this.props.dispatch(deleteAttribute(this.id));
    }

    render() {
            
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/attributes">
                            <Button iconBefore="arrow-left">
                                Inapoi la lista atribute
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16} alignSelf="flex-end">
                        <DeleteDialog
                            onDelete={this.handleDelete}
                            buttonLabel="Sterge atributul"
                            title="Confirmare stergere atribut"
                            confirmLabel="Sterg definitiv atributul"
                            message="Esti sigur ca vrei sa stergi atributul?"/>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Atribut - <strong>{this.props.attribute.name}</strong>
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <AttributeInfoBlock attribute={this.props.attribute}/>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        attribute: state.attributes.current
    }
}

export default connect(mapStateToProps)(ViewAttribute);